module.exports = __webpack_public_path__ + "img/model3.67508aba.png";